// components/SettingsDrawer.jsx
import React from 'react';
import {
  Drawer, Box, Typography, IconButton, Divider,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DroneSelector from './DroneSelector';

const SettingsDrawer = ({
  open, onClose,
  themeName, setThemeName,
  userLat, userLon, setUserLat, setUserLon,
  selectedDrone, setSelectedDrone,
  refreshInterval, setRefreshInterval,
  address, setAddress
}) => {
  const handleGPSClick = () => {
    if (!navigator.geolocation) return alert("Geolocation not supported.");
    navigator.geolocation.getCurrentPosition(pos => {
      setUserLat(pos.coords.latitude);
      setUserLon(pos.coords.longitude);
    }, () => alert("Permission denied or location unavailable."));
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 300, p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Settings</Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>

        <Divider sx={{ my: 2 }} />

        <FormControl fullWidth margin="dense">
          <InputLabel>Theme</InputLabel>
          <Select value={themeName} label="Theme" onChange={e => setThemeName(e.target.value)}>
            <MenuItem value="light">Light</MenuItem>
            <MenuItem value="dark">Dark</MenuItem>
            <MenuItem value="blue">Blue</MenuItem>
            <MenuItem value="green">Green</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>Refresh Interval</InputLabel>
          <Select
            value={refreshInterval}
            label="Refresh Interval"
            onChange={e => setRefreshInterval(Number(e.target.value))}
          >
            <MenuItem value={0}>Off</MenuItem>
            <MenuItem value={1}>1 min</MenuItem>
            <MenuItem value={3}>3 min</MenuItem>
            <MenuItem value={5}>5 min</MenuItem>
            <MenuItem value={10}>10 min</MenuItem>
          </Select>
        </FormControl>

        <Box mt={2}>
          <DroneSelector
            value={selectedDrone?.name || ''}           // pass name STRING
            onChange={(droneObj) => setSelectedDrone(droneObj)} // keep full OBJECT in state
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default SettingsDrawer;
